import { getFormIcon } from './formIcons';
import {
  formatLocalDateString,
  getEarliestBookableDate,
} from './tourDateValidation';

const PARENT_USER_TYPE = 'Parent or family member';

function isParentType(formData) {
  return formData?.user_type === PARENT_USER_TYPE;
}

function coerceNumericBounds(field) {
  if (field.type !== 'number') return field;
  const next = { ...field };
  if (next.min != null && next.min !== '') next.min = Number(next.min);
  if (next.max != null && next.max !== '') next.max = Number(next.max);
  return next;
}

/**
 * Converts CMS JSON form definition into FormComponent-ready config (React icons, dynamic labels/options).
 */
export function hydrateFormConfig(formDef) {
  if (!formDef) return null;

  const fields = (formDef.fields || []).map((field) => {
    let hydrated = {
      ...field,
      icon: getFormIcon(field.iconKey),
    };

    if (field.labelParent) {
      const baseLabel = field.label;
      hydrated.label = (formData) =>
        isParentType(formData) ? field.labelParent : baseLabel;
    }

    if (field.optionsParent?.length) {
      const baseOptions = field.options || [];
      hydrated.options = (formData) =>
        isParentType(formData) ? field.optionsParent : baseOptions;
    }

    if (field.type === 'date') {
      if (field.minBufferBusinessDays != null) {
        hydrated.minBufferBusinessDays = Number(field.minBufferBusinessDays);
        hydrated.min = formatLocalDateString(
          getEarliestBookableDate(hydrated.minBufferBusinessDays)
        );
      } else if (field.min == null) {
        hydrated.min = new Date().toISOString().split('T')[0];
      }
    }

    if (field.blockedMonths?.length) {
      hydrated.blockedMonths = field.blockedMonths.map(Number);
    }
    if (field.blockedMonthMessage) {
      hydrated.blockedMonthMessage = field.blockedMonthMessage;
    }

    if (field.type === 'number' && field.name === 'expected_graduation_year' && field.min == null) {
      hydrated.min = new Date().getFullYear();
      hydrated.max = new Date().getFullYear() + 10;
    }

    hydrated = coerceNumericBounds(hydrated);
    return hydrated;
  });

  return {
    title: formDef.title,
    subtitle: formDef.subtitle,
    icon: getFormIcon(formDef.iconKey),
    note: formDef.note,
    submitText: formDef.submitText,
    fields,
  };
}
